import { Route, Routes } from 'react-router-dom'
import Layout from '@/components/Layout'
import Home from '@/pages/Home'
import About from '@/pages/About'
import Contact from '@/pages/Contact'
import Faq from '@/pages/Faq'
import Registry from '@/pages/Registry'
import Store from '@/pages/Store'
import Register from '@/pages/Register'
import Checkout from '@/pages/Checkout'
import Registered from '@/pages/Registered'
import PrivacyPolicy from '@/pages/PrivacyPolicy'
import TermsOfService from '@/pages/TermsOfService'
import ColorPage from '@/pages/ColorPage'
import CertificatePage from '@/pages/CertificatePage'
import Merch from '@/pages/Merch'
import ApiDocs from '@/pages/ApiDocs'
import SlugResolver from '@/pages/SlugResolver'
import NotFound from '@/pages/NotFound'

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="contact" element={<Contact />} />
        <Route path="faq" element={<Faq />} />
        <Route path="registry" element={<Registry />} />
        <Route path="store" element={<Store />} />
        <Route path="register" element={<Register />} />
        <Route path="register/checkout" element={<Checkout />} />
        <Route path="register/success" element={<Registered />} />
        <Route path="api-docs" element={<ApiDocs />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="terms-of-service" element={<TermsOfService />} />
      </Route>
      {/* Color pages have their own full-bleed layout. */}
      <Route path="color" element={<ColorPage slug="example" />} />
      <Route path="color/:slug" element={<ColorPage />} />
      <Route path="color/:slug/certificate" element={<CertificatePage />} />
      <Route path="color/:slug/merch" element={<Merch />} />
      <Route path=":slug" element={<SlugResolver />} />
      <Route path=":slug/certificate" element={<SlugResolver view="certificate" />} />
      <Route path=":slug/merch" element={<SlugResolver view="merch" />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}
